import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImgHeaderComponent } from './img-header.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    ImgHeaderComponent
  ],
  exports: [
    ImgHeaderComponent
  ]
})
export class ImgHeaderModule { }



// WEBPACK FOOTER //
// ./src/app/img-header/img-header.module.ts